const API = 'https://waceas-backend.onrender.com';

async function request(path, options = {}) {
  const res = await fetch(`${API}${path}`, options);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || 'Erreur serveur');
  }
  return res.json();
}

export const fetchPhotos = () =>
  request('/api/media?type=photo');

export const fetchArticles = () =>
  request('/api/articles');

export const fetchPublicMembers = () =>
  request('/api/members/public');

export const sendMessage = (data) =>
  request('/api/messages', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const submitMembership = (data) =>
  request('/api/members', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
